var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", [
                _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.agregarItem }
                  },
                  [_c("i", { staticClass: "fa fa-plus" })]
                )
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("Código")]),
              _vm._v(" "),
              _c("th", [_vm._v("Serie")]),
              _vm._v(" "),
              _c("th", [_vm._v("Descripción")]),
              _vm._v(" "),
              _c("th", [_vm._v("Cantidad")]),
              _vm._v(" "),
              _c("th")
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.modelValue, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-info btn--text",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.editarItem(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-edit" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.codigo))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.serie))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      attrs: {
                        tooltip:
                          item.descripcion !== ""
                            ? item.descripcion
                            : "Seleccione..."
                      }
                    },
                    [_vm._v(_vm._s(item.descripcion))]
                  ),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.cantidad))]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-danger btn--text",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.eliminarItem(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-trash" })]
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.modelValue.length === 0,
                      expression: "modelValue.length === 0"
                    }
                  ]
                },
                [_vm._m(0)]
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "itemGuiaRemision",
            width: "60%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("item-guia-remision", {
            attrs: { clickToClose: false },
            on: { cancelar: _vm.cancelarItem, input: _vm.inputItem },
            model: {
              value: _vm.selectedItem,
              callback: function($$v) {
                _vm.selectedItem = $$v
              },
              expression: "selectedItem"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "itemsComprobante",
            width: "70%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("items-comprobante", {
            attrs: { idItem: _vm.idItem, idComprobante: _vm.idComprobante },
            on: {
              cancelar: function($event) {
                return _vm.$modal.hide("itemsComprobante")
              },
              input: _vm.inputItems
            },
            model: {
              value: _vm.modelValue,
              callback: function($$v) {
                _vm.modelValue = $$v
              },
              expression: "modelValue"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "6" } }, [
      _c("strong", [_vm._v("No se ha agregado ítems.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51fd390e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51fd390e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaItemGuiaRemision.vue
// module id = 444
// module chunks = 0